define('PDPBanner.Entry',
[
	'PDPBanner.View'
],
function (
	PDPBannerView
){
	'use strict';

    //Anchor Group - An Phan
    //Registers extension view to product display page.

	return  {
		mountToApp: function mountToApp (container){
			const Layout = container.getComponent('Layout');
			
			if(Layout){
				Layout.registerView('PDPBannerView', function() { 
					return new PDPBannerView({ container: container });
				});
			}

		}
	};
});
